var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardBody, CardFooter, FormGroup, Form, Label, Input, Container, CardHeader } from 'reactstrap';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import { getEnumKeys } from '../../../utils/enumUtils';
import SchemaTriggerIntervalValueType from '../../../data/SchemaTriggerIntervalValueType';
import ServiceSchemaModel from '../../../models/ServiceSchemaModel';
import CreateServiceSchemaCommand from '../../../commands/services/CreateServiceSchemaCommand';
import UpdateServiceSchemaCommand from '../../../commands/services/UpdateServiceSchemaCommand';
import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';
import FormField from '../../components/ui/FormField/FormField';
import SchemaTriggerType from '../../../data/SchemaTriggerType';
import Signals from "../../../signals/Signals";
import CloseButton from "../../components/ui/CloseButton/CloseButton";
/**
 *
 */
var ServiceSchemaOverlay = /** @class */ (function (_super) {
    __extends(ServiceSchemaOverlay, _super);
    /**
     *
     */
    function ServiceSchemaOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            submitting: false,
            serviceSchema: new ServiceSchemaModel({})
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        return _this;
    }
    /**
     *
     */
    ServiceSchemaOverlay.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    ServiceSchemaOverlay.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    /**
     *
     */
    ServiceSchemaOverlay.prototype.initialize = function () {
        var id = this.props.id;
        if (id && id !== 'add') {
            var serviceSchemaCollection = this.context.serviceSchemaCollection;
            var serviceSchema = serviceSchemaCollection.findById(id);
            // Clone selected schema, only update collection with schema after update
            this.setState({ isEditing: true, serviceSchema: new ServiceSchemaModel(serviceSchema) });
        }
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ServiceSchemaOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl, ['url']);
    };
    /**
     *
     * @returns {*}
     */
    ServiceSchemaOverlay.prototype.render = function () {
        var _a = this.props, intl = _a.intl, className = _a.className;
        var session = this.context.session;
        if (!session.isLoggedIn) {
            return null;
        }
        var _b = this.state, isEditing = _b.isEditing, serviceSchema = _b.serviceSchema;
        var triggerReminderBeforeIntervalValue = serviceSchema.triggerReminderBeforeIntervalValue, triggerReminderBeforeInterval = serviceSchema.triggerReminderBeforeInterval, triggerType = serviceSchema.triggerType, triggerIntervalValue = serviceSchema.triggerIntervalValue, triggerIntervalValueType = serviceSchema.triggerIntervalValueType, description = serviceSchema.description, name = serviceSchema.name;
        // Convert milliseconds to days
        var reminderBeforeIntervalConverted = SchemaTriggerIntervalValueType.isPeriodial(serviceSchema.triggerIntervalValueType) ? Math.round(triggerReminderBeforeInterval / 86400000) : triggerReminderBeforeInterval;
        if (isEditing) {
            reminderBeforeIntervalConverted = SchemaTriggerIntervalValueType.isPeriodial(serviceSchema.triggerIntervalValueType) ? Math.round(triggerReminderBeforeIntervalValue / 86400000) : triggerReminderBeforeIntervalValue;
        }
        return (React.createElement(Container, { className: 'service-schema-overlay w-25 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                React.createElement(Form, { className: "", onChange: this.onInputChange, onSubmit: this.onSubmit, autoComplete: isEditing ? 'no' : null },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardHeader, null,
                            React.createElement("h4", null,
                                React.createElement(FormattedMessage, { id: intl.formatMessage({ id: isEditing ? 'page.service.schema.title.edit' : 'page.service.schema.title.add' }) }))),
                        React.createElement(CardBody, null,
                            React.createElement(FormGroup, null,
                                React.createElement("div", { className: "row" },
                                    React.createElement("div", { className: "col" },
                                        React.createElement(Label, { for: "name" },
                                            React.createElement(FormattedMessage, { id: "page.service.schema.field.name" })))),
                                React.createElement(FormField, null,
                                    React.createElement(Input, { className: "col-12", type: "text", name: "name", id: "name", autoComplete: "off", value: name, required: true }))),
                            React.createElement(FormGroup, null,
                                React.createElement("div", { className: "row" },
                                    React.createElement("div", { className: "col" },
                                        React.createElement(Label, { for: "description" },
                                            React.createElement(FormattedMessage, { id: "page.service.schema.field.description" })))),
                                React.createElement(FormField, null,
                                    React.createElement("textarea", { className: "form-control col-12", name: "description", id: "description", autoComplete: "off", value: description, required: true }, description))),
                            React.createElement("fieldset", { disabled: isEditing },
                                React.createElement(FormGroup, null,
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col" },
                                            React.createElement("label", { htmlFor: "triggerType" },
                                                React.createElement(FormattedMessage, { id: "page.service.schema.field.triggertype" })))),
                                    React.createElement(FormField, null,
                                        React.createElement("select", { className: "form-control col-12", name: "triggerType", id: "triggerType", disabled: isEditing, required: true, value: triggerType }, getEnumKeys(SchemaTriggerType).map(function (type) {
                                            return React.createElement("option", { key: type, value: SchemaTriggerType[type] }, intl.formatMessage({ id: 'service.schema.triggertype.' + type }));
                                        })))),
                                triggerType === SchemaTriggerType.INTERVAL ?
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "type" },
                                                    React.createElement(FormattedMessage, { id: "page.service.schema.field.interval" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "input-group align-items-center" },
                                                React.createElement("div", { className: "input-group-append flex-shrink-1 flex-md-grow-1" },
                                                    React.createElement("select", { className: 'service-schema__interval-value ' + (triggerIntervalValueType === SchemaTriggerIntervalValueType.NONE ? 'service-schema__interval-value--full' : '') + ' form-control col-12', name: "triggerIntervalValueType", id: "triggerIntervalValueType", disabled: isEditing, required: true, value: triggerIntervalValueType }, getEnumKeys(SchemaTriggerIntervalValueType).map(function (type) {
                                                        if (type === 'TIMEINTERVAL_SECONDS' && !window.debug) {
                                                            return null;
                                                        }
                                                        return React.createElement("option", { key: type, value: SchemaTriggerIntervalValueType[type] }, intl.formatMessage({ id: 'service.schema.triggerintervaltype.' + type }));
                                                    }))),
                                                triggerIntervalValueType !== SchemaTriggerIntervalValueType.NONE ?
                                                    React.createElement(Input, { className: "flex-grow-1 flex-shrink-1 border-left-0", disabled: isEditing, type: "number", min: 0, step: 1, name: "triggerIntervalValue", id: "triggerIntervalValue", autoComplete: "off", value: triggerIntervalValue, required: true }) : null))) : null,
                                triggerType === SchemaTriggerType.INTERVAL && triggerIntervalValueType !== SchemaTriggerIntervalValueType.NONE ?
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "type" },
                                                    React.createElement(FormattedMessage, { id: "page.service.schema.field.reminderinterval" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "input-group" },
                                                React.createElement(Input, { className: "flex-grow-1 flex-shrink-1", type: "number", disabled: isEditing, min: 0, step: 1, name: "triggerReminderBeforeInterval", id: "triggerReminderBeforeInterval", autoComplete: "off", value: reminderBeforeIntervalConverted, required: true }),
                                                React.createElement("div", { className: "input-group-append" },
                                                    React.createElement("span", { className: "input-group-text" },
                                                        triggerIntervalValueType === SchemaTriggerIntervalValueType.OPERATIONAL_HOURS ? React.createElement(FormattedMessage, { id: "page.service.schema.reminderoperationalhours", defaultMessage: "Uren vooraf" }) : null,
                                                        SchemaTriggerIntervalValueType.isPeriodial(triggerIntervalValueType) ? React.createElement(FormattedMessage, { id: "page.service.schema.reminderdays", defaultMessage: "Dagen vooraf" }) : null))))) : null)),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                isEditing ?
                                    React.createElement("button", { className: "btn btn-outline-primary mr-3", onClick: this.onCancel, type: "button" },
                                        React.createElement(FormattedMessage, { id: "page.service.schema.cancel" })) : null,
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.service.schema.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } })));
    };
    /**
     *
     * @param event
     */
    ServiceSchemaOverlay.prototype.onInputChange = function (event) {
        var serviceSchema = this.state.serviceSchema;
        switch (event.target.name) {
            case 'triggerType':
                if (event.target.value !== SchemaTriggerType.INTERVAL) {
                    serviceSchema.triggerIntervalValueType = 0;
                    serviceSchema.triggerReminderBeforeInterval = 0;
                }
                serviceSchema[event.target.name] = parseInt(event.target.value);
                break;
            case 'triggerIntervalValueType':
                serviceSchema[event.target.name] = parseInt(event.target.value);
                serviceSchema.triggerReminderBeforeInterval = 0; // reset reminder before value to deal with day/operational hour switch
                break;
            case 'triggerIntervalValue':
                serviceSchema[event.target.name] = parseInt(event.target.value);
                break;
            case 'triggerReminderBeforeInterval':
                switch (serviceSchema.triggerIntervalValueType) {
                    case SchemaTriggerIntervalValueType.TIMEINTERVAL_DAYS:
                    case SchemaTriggerIntervalValueType.TIMEINTERVAL_WEEKS:
                    case SchemaTriggerIntervalValueType.TIMEINTERVAL_MONTHS:
                    case SchemaTriggerIntervalValueType.TIMEINTERVAL_YEARS:
                        serviceSchema[event.target.name] = parseInt(event.target.value) * 86400000; // convert days to milliseconds
                        break;
                    default:
                        serviceSchema[event.target.name] = parseInt(event.target.value);
                }
                break;
            default:
                serviceSchema[event.target.name] = event.target.value;
        }
    };
    /**
     *
     * @param event
     */
    ServiceSchemaOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var serviceSchema = this.state.serviceSchema;
        var intl = this.props.intl;
        if (!serviceSchema.id) {
            var command = new CreateServiceSchemaCommand();
            command.execute(serviceSchema, session.user.organisation, intl)
                .then(this.onSuccess)
                .catch(this.onError);
        }
        else {
            var command = new UpdateServiceSchemaCommand();
            command.execute(serviceSchema, session.user.organisation.id, intl)
                .then(this.onSuccess)
                .catch(this.onError);
        }
        this.setState({ errors: null, submitting: true });
    };
    /**
     *
     * @param user
     */
    ServiceSchemaOverlay.prototype.onSuccess = function (user) {
        this.setState({ submitting: false, errors: null });
        Signals.HideOverlay.dispatch();
        // History.push(Routes.SERVICE_SCHEMAS.getPath());
    };
    /**
     *
     * @param error
     */
    ServiceSchemaOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    ServiceSchemaOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    ServiceSchemaOverlay = __decorate([
        observer
    ], ServiceSchemaOverlay);
    return ServiceSchemaOverlay;
}(React.Component));
ServiceSchemaOverlay.contextType = ApplicationContext;
export default injectIntl(ServiceSchemaOverlay);
